import React, { useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { CiviliteSelect } from './CiviliteSelect';
import { formatNom, formatPrenom } from '../lib/personne';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ['email', 'Email', 'email'],
  ['telephone', 'Téléphone', 'tel'],
  ['date_naissance', 'Date de naissance', 'date'],
  ['entreprise', 'Entreprise', 'text'],
  ['poste', 'Poste', 'text'],
  ['adresse', 'Adresse', 'text'],
  ['ville', 'Ville', 'text'],
  ['code_postal', 'Code postal', 'text'],
];

export const CandidatEditDialog = ({ candidat, open, onOpenChange, onSaved }) => {
  const [form, setForm] = useState(candidat || {});
  const [saving, setSaving] = useState(false);

  React.useEffect(() => { if (open) setForm(candidat || {}); }, [open, candidat]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { id, created_at, ...payload } = form;
      payload.email = payload.email || null;
      const res = await axios.put(`${API_URL}/candidats/${candidat.id}`, payload);
      toast.success('Fiche candidat mise à jour');
      onSaved?.(res.data);
      onOpenChange(false);
    } catch (err) { toast.error(err.response?.data?.detail || 'Erreur lors de la mise à jour'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="candidat-edit-dialog">
        <DialogHeader><DialogTitle>Modifier la fiche de {candidat?.nom} {candidat?.prenom}</DialogTitle></DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-[110px_1fr_1fr] gap-3">
            <CiviliteSelect value={form.civilite} onChange={(v) => set('civilite', v)} testId="edit-candidat-civilite" />
            <div className="space-y-1.5"><Label>Prénom *</Label><Input value={form.prenom || ''} onChange={(e) => set('prenom', formatPrenom(e.target.value))} required data-testid="edit-candidat-prenom" /></div>
            <div className="space-y-1.5"><Label>Nom *</Label><Input value={form.nom || ''} onChange={(e) => set('nom', formatNom(e.target.value))} required data-testid="edit-candidat-nom" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {FIELDS.map(([k, label, type]) => (
              <div key={k} className="space-y-1.5">
                <Label>{label}</Label>
                <Input type={type} value={form[k] || ''} onChange={(e) => set(k, e.target.value)} data-testid={`edit-candidat-${k}`} />
              </div>
            ))}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
            <Button type="submit" disabled={saving} className="bg-indigo-600 hover:bg-indigo-700" data-testid="edit-candidat-submit">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Enregistrer
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
